<div class="dropdown" [class.active]="dropdownIsOpen">
  <button type="button" (click)="toggleDropdown()" class="dropdown__trigger">
    {{ label }}
    <img
      src="assets/img/icons/blue-triangle.svg"
      alt=""
      class="dropdown__arrow"
    />
  </button>
  <div class="dropdown__content">
    <ng-content></ng-content>
  </div>
</div>
